import { getYearAdjustedDate } from 'util/formatters/dateFormatter';

export const START_PLANTING_DATE = getYearAdjustedDate({ date: 'YYYY-04-15' }).toISOString();
